import { render, staticRenderFns } from "./DialogsRoot.vue?vue&type=template&id=2cd0496c"
import script from "./DialogsRoot.vue?vue&type=script&lang=js"
export * from "./DialogsRoot.vue?vue&type=script&lang=js"
import style0 from "./DialogsRoot.vue?vue&type=style&index=0&id=2cd0496c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports